// BloodSugarCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Kadar Gula Darah - Hitung Gula Darah Normal";
const DESCRIPTION =
  "Kalkulator kadar gula darah: tentukan apakah hasil Anda dalam kisaran normal (acak, puasa, setelah makan, atau kumulatif) berdasarkan jenis pemeriksaan! Alat medis dengan interpretasi rinci untuk setiap kondisi - dengan tips mengatur gula untuk penderita diabetes dan pradiabetes.";
const KEYWORDS =
  "kalkulator gula, kadar gula darah, pemeriksaan gula acak, pemeriksaan gula puasa";
const OG_URL = "https://do-calculate.com/calculator/id/blood-sugar-calculator/";
function BloodSugarCalculator() {
  const [sugarLevel, setSugarLevel] = useState("");
  const [testType, setTestType] = useState("Pemeriksaan Gula Acak");
  const [result, setResult] = useState("");
  const [alertClass, setAlertClass] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (sugarLevel) {
        const level = parseFloat(sugarLevel);
        let normalRange;
        let minLevel, maxLevel;
        let message;
        if (testType === "Pemeriksaan Gula Acak") {
          normalRange = "140-200 mg/dl";
          minLevel = 140;
          maxLevel = 200;
        } else if (testType === "Pemeriksaan Gula Puasa") {
          normalRange = "70-100 mg/dl";
          minLevel = 70;
          maxLevel = 100;
        }
        if (level < minLevel) {
          message = `Peringatan: Tingkat yang dimasukkan ${level} mg/dl lebih rendah dari kisaran normal untuk ${testType} (${normalRange}).`;
          setAlertClass("alert alert-warning");
        } else if (level > maxLevel) {
          message = `Peringatan: Tingkat yang dimasukkan ${level} mg/dl lebih tinggi dari kisaran normal untuk ${testType} (${normalRange}).`;
          setAlertClass("alert alert-warning");
        } else {
          message = `Sangat baik: Tingkat yang dimasukkan ${level} mg/dl dalam kisaran normal untuk ${testType} (${normalRange}).`;
          setAlertClass("alert alert-success");
        }
        setResult(message);
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator gula darah cerdas adalah alat yang berguna dan andal yang membantu Anda menentukan kadar gula darah dengan mudah. Cukup masukkan pembacaan meter glukosa darah dalam miligram per desiliter (mg/dl) dan pilih jenis pemeriksaan yang Anda lakukan (acak atau puasa). Kalkulator kami akan memberikan hasil instan dengan penjelasan sederhana tentang artinya. Baik Anda menderita diabetes atau hanya ingin memantau kesehatan Anda, kalkulator kami adalah alat yang berharga untuk menjaga kontrol gula darah yang optimal.
                </p>
                <p>Untuk menghitung kadar gula, Anda dapat mengikuti langkah-langkah berikut:</p>
                <ul>
                  <li>
                    Masukkan kadar gula darah dalam miligram per desiliter (mg/dl).
                  </li>
                  <li>
                    Pilih jenis pemeriksaan: pemeriksaan gula acak atau pemeriksaan gula puasa.
                  </li>
                </ul>
                <p>Kalkulator ini dikembangkan untuk memudahkan mengetahui kadar gula darah.</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="level">
                          Masukkan kadar gula
                        </label>
                      </b>
                      <input
                        id="level"
                        type="number"
                        value={sugarLevel}
                        onChange={(e) => setSugarLevel(e.target.value)}
                        placeholder="Masukkan kadar gula"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="type">
                          Pilih jenis pemeriksaan
                        </label>
                      </b>
                      <select
                        id="type"
                        className="form-control"
                        value={testType}
                        onChange={(e) => setTestType(e.target.value)}
                        style={{ width: "75%" }}
                      >
                        <option value="Pemeriksaan Gula Acak">
                          Pemeriksaan Gula Acak
                        </option>
                        <option value="Pemeriksaan Gula Puasa">
                          Pemeriksaan Gula Puasa
                        </option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className={alertClass}>
                      <h4>Hasil:</h4>
                      <p className="text-black">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Berapa kadar gula normal?
                    </h2>
                  </u>
                  <p>Kadar gula normal tergantung pada jenis pemeriksaan.</p>
                  <p>
                    Dalam kasus pemeriksaan gula acak, kisaran normal adalah antara 80 dan 140 mg/dl.
                  </p>
                  <p>
                    Dalam kasus pemeriksaan gula puasa, kisaran normal adalah antara 70 dan 100 mg/dl.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    Pastikan untuk mengikuti saran dokter untuk menjaga kadar gula normal.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Apa perbedaan antara kedua pemeriksaan?
                    </h2>
                  </u>
                  <p>
                    Pemeriksaan acak dapat dilakukan kapan saja sedangkan pemeriksaan puasa memerlukan puasa untuk periode tertentu.
                  </p>
                  <ul>
                    <li>Pemeriksaan gula acak: tidak memerlukan puasa.</li>
                    <li>Pemeriksaan gula puasa: memerlukan puasa 8-12 jam.</li>
                  </ul>
                  <p>Pemilihan pemeriksaan tergantung pada arahan dokter dan kebutuhan pasien.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Patuhi saran dokter untuk mendapatkan hasil terbaik.
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BloodSugarCalculator;